export class Operators {
  public static filter = [
    { code: 0, key: 'select' },
    { code: 1, key: 'lessThan' },
    { code: 2, key: 'greaterThan' },
    { code: 3, key: 'lessThanOrEqualTo' },
    { code: 4, key: 'greaterThanOrEqualTo' },
    { code: 5, key: 'equalTo' },
    { code: 5, key: 'notEqualTo' }
  ];
}
